import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import InlineSVG from 'svg-inline-react';
import RotationMeter from '../../objects/kpi/RotationKpiMeter';
import Badge from '../../objects/badges/Badge';

import * as localStorage from '../../../localStorage/localStorage';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as learningPlanConstants from '../../../constants/learningPlanConstants';

class LearninPlanBitePanel extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filter: this.props.filter,
            userBite: this.props.userBite,
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.menuData),
            biteLocale: appHelper.getLocalData(this.props.bite),
            primaryKpi: appHelper.isDefined(this.props.bite.score_kpi) ? this.props.bite.score_kpi : {},
            performance_kpis: appHelper.isDefined(this.props.bite.performance_kpis) && this.props.bite.performance_kpis.length ? this.props.bite.performance_kpis : [],
            assets: {
                thumbnail: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                icon: {
                    src: "",
                    type: "",
                    type_id: ""
                }
            },
            checkForUpdate: false,
            badges: this.props.bite.badges,
            showAchievedCount: true,
            showAchievedState: true,
            isEnabled: false,
            updateEnabledBite: false,
            optionLabel: appHelper.getLocaleString("optional_label")
        };
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setBite = this.setBite.bind(this);
        this.goToBite = this.goToBite.bind(this);
        this.getUserProgressClass = this.getUserProgressClass.bind(this);
        this.setEnabledState = this.setEnabledState.bind(this);
        this.isBiteEnabled = this.isBiteEnabled.bind(this);
        this.getBiteEnabledState = this.getBiteEnabledState.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {
        this.getAssets();
        this.setEnabledState();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.filter !== nextProps.filter) {
            this.setState({filter: nextProps.filter});
        }
        if (this.state.userBite !== nextProps.userBite) {
            this.setState({
                userBite: Object.assign({}, nextProps.userBite),
                updateEnabledBite: true
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.menuData),
                biteLocale: appHelper.getLocalData(this.props.bite),
                optionLabel: appHelper.getLocaleString("optional_label")
            });
        }
        this.setEnabledState();
    }

    componentDidUpdate() {
        if (this.state.checkForUpdate && this.props.trackingData.lesson_location === this.props.bite.screens[0].screen_id) {
            this.goToBite();
        }

        if (this.state.updateEnabledBite) {
            this.setEnabledState();
        }
    }

    getAssets() {

        let iconAsset = appHelper.getIconAsset(this.props.menuData.icon);

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                icon: iconAsset
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setBite() {

        if (this.isBiteEnabled()) {
            let screen_id = this.props.bite.screens[0].screen_id;
            this.props.actions.setNewLessonLocation(screen_id);
            this.setState({checkForUpdate: true});
            //this.context.router.push(this.props.bite.bite_id);

        }
    }

    goToBite() {
        this.setState({checkForUpdate: false});
        this.context.router.push(this.props.bite.bite_id);
    }

    getUserProgressClass() {
        let className = ``;

        if (this.state.userBite.status === objectConstants.STATUS_NOT_REQUIRED) {
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_IN_PROGRESS) {
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_COMPLETE) {
            className += `${objectConstants.CLASS_COMPLETE} `;
        } else {
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }

        return className;
    }

    setEnabledState() {
        this.setState({
            updateEnabledBite: false
        });
        let isEnabled = false;
        switch (this.props.learningPlan.navigation_type) {
            case learningPlanConstants.LP_NAVIGATION_TYPE_LINEAR:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
                break;
            case learningPlanConstants.LP_NAVIGATION_TYPE_OPEN:
                isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite, this.props.userData);
                break;
            case learningPlanConstants.LP_NAVIGATION_TYPE_FIRST_ANY_LAST:
                isEnabled = appHelper.checkFirstLastAnyMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
                break;
            default:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
        }

        this.setState({isEnabled: isEnabled});
    }


    isBiteEnabled() {
        return this.state.isEnabled;
    }

    getBiteEnabledState() {
        return this.isBiteEnabled() ? "" : "disabled";
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.setBite();
        }
    }

    // <InlineSVG className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)}/>
    render() {
        let showKpis = this.props.learningPlan.kpi_display === learningPlanConstants.LP_PRIMARY_KPI_DISPLAY_BITE_MENU && appHelper.isDefined(this.state.primaryKpi.kpi_id) && this.state.primaryKpi.kpi_id !== null && this.state.primaryKpi.is_visible;
        let showBadges = this.state.badges.length > 0 && (this.props.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_BITE_MENU || this.props.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER_AND_BITE);
        return (
            this.state.userBite.visible
                ?
                <div className={`menu-panel ${this.getBiteEnabledState()}`} onClick={this.setBite}
                     onKeyDown={this.setKeyboardAccessibility} tabIndex={0} role="link">

                    <div className={`icon-container ${this.getUserProgressClass()}`}>
                        {
                            appHelper.isDefined(this.state.assets.icon) && this.state.assets.icon.src.length > 0
                                ?
                                <div className="thumbnail-icon">
                                    <img className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)} alt=""/>
                                </div>
                                : null
                        }

                    </div>

                    <div className="content-container">
                        <div className={`bite-title`}>
                            {
                                appHelper.isDefined(this.state.locale.sur_title) && this.state.locale.sur_title !== null && this.state.locale.sur_title.length > 0
                                    ?
                                    <div className="sur-title">{this.state.locale.sur_title}</div>
                                    :
                                    null
                            }
                            <span
                                className={`title ${this.getUserProgressClass()}`}> {this.state.biteLocale.title}</span>

                            {!this.props.required
                                ?
                                <span className="required">{this.state.optionLabel}</span>
                                :
                                null
                            }


                        </div>
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                            ?
                            <div className="description"
                                 dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            : null
                        }


                    </div>
                    {showKpis || showBadges
                        ?
                        <div className="scoring-container">
                            {
                                showKpis
                                    ?
                                    <div className="scoring-col">
                                        <RotationMeter bite_id={this.props.bite.bite_id}
                                                       kpiDefaults={this.state.primaryKpi}
                                                       meterParams={kpiModels.SMALL_KPI_ROTATION_METER_PARAMS}
                                                       displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                    </div>
                                    :
                                    null
                            }

                            {showBadges
                                ?
                                <div className="scoring-col">
                                    <div className="earned-badges">
                                        <div className="icon icons8-achievement-filled" role="presentation"/>
                                        <div className="badge-count">
                                    <span className="status-indicator">
                                    {this.state.badges.length.toString()}
                                    </span>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                        :
                        null
                    }
                </div>
            :
                null

        );
    }
}


/*
* {this.state.performance_kpis.length > 0
                                    ?
                                    this.state.performance_kpis.map(kpi =>
                                    <div className="kpi-meter-container" key={kpi.kpi_id}>
                                        <div className="kpi-meter">
                                            <RotationMeter bite_id={this.props.bite.bite_id}
                                                           kpiDefaults={kpi}
                                                           meterParams={kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS}
                                                           displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                        </div>
                                    </div>
                                     )
                                    :null
                                }

* */
LearninPlanBitePanel.propTypes = {
    menuData: PropTypes.object.isRequired,
    bite: PropTypes.object.isRequired,
    required: PropTypes.bool.isRequired,
    filter: PropTypes.string.isRequired,
    userBite: PropTypes.object.isRequired,
    learningPlan: PropTypes.object.isRequired,
    learningPlanBites: PropTypes.array.isRequired,
    userData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

LearninPlanBitePanel.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userBite: userDataHelper.getBiteUserData(state.userData, ownProps.bite.bite_id),
        userData: state.userData,
        trackingData: state.trackingData,
        contentData: state.contentData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearninPlanBitePanel);



/** WEBPACK FOOTER **
 ** ./src/components/menus/learningPlan/LearninPlanBitePanel.js
 **/